export default __webpack_public_path__ + "static/media/BASH-DAI.38270cf4.png";